import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { FacebookAppStoreLoginRequest } = protos;

/**
 * Logs a patron into the Facebook App Store
 * @param {Object} request FacebookAppStoreLoginRequest proto.
 * @returns {Object} A redux TockApi action.
 */
export function loginAppStore(request: dashboard.IFacebookAppStoreLoginRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/integrations/facebook/appstore/login',
      request: FacebookAppStoreLoginRequest.fromObject(request),
      type: AppConstants.FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN,
    },
  };
}

export function uninstallFacebookBusiness() {
  return {
    TockApi: {
      deleteProto: '/integrations/facebook/business/uninstall',
      type: AppConstants.FACEBOOK_BUSINESS_EXTENSION_UNINSTALL,
    },
  };
}
